/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUserWallCredentialsStreemWallFromJSON(json) {
    return StreemApiUserWallCredentialsStreemWallFromJSONTyped(json, false);
}
export function StreemApiUserWallCredentialsStreemWallFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': !exists(json, 'token') ? undefined : json['token'],
        'mapName': !exists(json, 'map_name') ? undefined : json['map_name'],
    };
}
export function StreemApiUserWallCredentialsStreemWallToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
        'map_name': value.mapName,
    };
}
//# sourceMappingURL=StreemApiUserWallCredentialsStreemWall.js.map